import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function Cart() {
  const [carrinho, setCarrinho] = useState([]);
  const [error, setError] = useState('');

  const loadCart = () => {
    api.get('/cart')
      .then((response) => setCarrinho(response.data.carrinho || []))
      .catch((err) => console.error('Erro ao buscar carrinho:', err));
  };

  useEffect(() => {
    loadCart();
  }, []);

  const removeProduct = async (id) => {
    try {
      await api.post('/cart/remove', { id });
      loadCart();
    } catch (err) {
      setError('Erro ao remover produto.');
    }
  };

  const updateQuantity = async (id, quantidade) => {
    const updated = carrinho.map((item) => (item.id === id ? { ...item, quantidade } : item));
    try {
      await api.post('/cart/update', { cart: updated });
      setCarrinho(updated);
    } catch (err) {
      setError('Erro ao atualizar carrinho.');
    }
  };

  const total = carrinho.reduce((sum, item) => sum + (item.preco || 0) * (item.quantidade || 1), 0);

  return (
    <main className="page-container">
      <h2>Carrinho</h2>
      {error && <div className="alert-error">{error}</div>}
      {carrinho.length === 0 ? (
        <p>Seu carrinho está vazio.</p>
      ) : (
        <div className="cart-list">
          {carrinho.map((item) => (
            <div key={item.id} className="card cart-card">
              <h3>{item.nome}</h3>
              <p>{item.precoFormatado || item.preco}</p>
              <label>
                Quantidade
                <input type="number" min="1" value={item.quantidade || 1} onChange={(e) => updateQuantity(item.id, Number(e.target.value))} />
              </label>
              <button className="btn-secondary" onClick={() => removeProduct(item.id)}>Remover</button>
            </div>
          ))}
          <div className="checkout-summary">
            <p>Total: R$ {total.toFixed(2)}</p>
            <Link to="/checkout" className="btn-primary">Finalizar compra</Link>
          </div>
        </div>
      )}
    </main>
  );
}
